import React, {useEffect, useState} from 'react';
import CourseHomeUI from '../view/CourseHomeUI';
import {inject, observer} from 'mobx-react';
import CourseHomeStore from '../store/CourseHomeStore';
import {CoursePresentation} from '../../../data/models/Course/CoursePresentation';
import {useNavigate, useParams} from 'react-router-dom';
import {LearnerCourseProgress} from '../../../data/models/Course/LearnerCourseProgress';
import UserInfoStore from '../../../stores/UserInfoStore';
import {LessonType} from '../../../data/staticValues/lessonTypes';

interface Props {
  courseHomeStore?: CourseHomeStore;
  userInfoStore?: UserInfoStore;
}

const CourseHomeContainer = inject(
  'courseHomeStore',
  'userInfoStore',
)(
  observer(({courseHomeStore, userInfoStore}: Props) => {
    const [coursePresentation, setCoursePresentation] =
      useState<CoursePresentation>();
    const [courseProgress, setCourseProgress] =
      useState<LearnerCourseProgress>();

    const navigate = useNavigate();
    const {courseId} = useParams();

    useEffect(() => {
      userInfoStore!.fetchUserInfo();
      fetchPresentation();
      fetchProgress();
    }, []);

    const fetchProgress = () => {
      if (courseId) {
        courseHomeStore!
          .getLearnerCourseProgress(courseId)
          .then(setCourseProgress);
      }
    };

    const onLessonClick = (lessonId: string) => {
      if (courseId) {
        navigate(`/course/${courseId}/lesson/${lessonId}`);
      }
    };

    const fetchPresentation = () => {
      if (courseId) {
        courseHomeStore!
          .getCoursePresentation(courseId, [
            LessonType.LESSON,
            LessonType.MICROLESSON,
          ])
          .then(setCoursePresentation);
      }
    };

    const getCourseLink = () => {
      return `/home`;
    };

    const onContinue = (lessonId: string) => {
      navigate(`/course/${courseId}/lesson/${lessonId}`);
    };

    const onSelfEnroll = () => {
      if (courseId) {
        courseHomeStore!.selfEnroll(courseId).then(fetchProgress);
      }
    };

    return (
      <>
        <CourseHomeUI
          userInfo={userInfoStore!.userInfo}
          course={coursePresentation?.course}
          organization={coursePresentation?.organization}
          courseLink={getCourseLink()}
          onLessonClick={onLessonClick}
          courseProgress={courseProgress}
          onContinue={onContinue}
          onSelfEnroll={onSelfEnroll}
        />
      </>
    );
  }),
);

export default CourseHomeContainer;
